<template>
	<table class="table table-responsive table-hover admin-table">
		<thead>
			<tr>
				<th>N°</th>
				<th>Título</th>
				<th>Descuento</th>
				<th>Vigencia</th>
				<th>Utilizada</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr class="clickable-row">
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td>
					<i class="fa fa-pencil" aria-hidden="true"></i>
					<i class="fa fa-trash" aria-hidden="true" @click="remove(item)"></i>
				</td>
			</tr>
		</tbody>
	</table>
	<!-- <pagination></pagination> -->
</template>

<script>
export default {
	// ------ PROPS ------

	props: ['list', 'url', 'remove', 'query'],

	// ------ DATA ------
	
	data() {
		return {};
	},

	// ------ RENDER ------

	computed: {
		render_list() {
			return this.list;
		},

		render_url() {
			return this.url;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-table-codes.vue?277742d4